import styled from 'styled-components';

export const StyledRequestACallForm = styled.form.attrs({
  'data-netlify': true
})`
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  padding: 30px 30px 102px;
  box-sizing: border-box;

  > button {
    display: block;
    margin: 32px auto 0;
    font-size: 18px;
    min-width: 256px;
  }
`;
